export var ClientTypeEnum;
(function (ClientTypeEnum) {
    ClientTypeEnum["DESK_TOP"] = "DESK_TOP";
    ClientTypeEnum["ANDROID"] = "ANDROID";
    ClientTypeEnum["IOS"] = "IOS";
    ClientTypeEnum["JS"] = "JS";
})(ClientTypeEnum || (ClientTypeEnum = {}));
export var AnnouncementTypeEnum;
(function (AnnouncementTypeEnum) {
    AnnouncementTypeEnum["TIPS"] = "tips";
    AnnouncementTypeEnum["NPS_SCORE"] = "nps_score";
    AnnouncementTypeEnum["NPS_YES_OR_NO"] = "nps_yes_or_no";
    AnnouncementTypeEnum["NEW_USE"] = "new_use";
    AnnouncementTypeEnum["ACTIVITY"] = "activity";
    AnnouncementTypeEnum["SYSTEM_MAINTAIN"] = "system_maintain";
    AnnouncementTypeEnum["FEATURE"] = "feature";
})(AnnouncementTypeEnum || (AnnouncementTypeEnum = {}));
export var AnnouncementOperateTypeEnum;
(function (AnnouncementOperateTypeEnum) {
    AnnouncementOperateTypeEnum["CLOSE"] = "CLOSE";
    AnnouncementOperateTypeEnum["SEEN"] = "SEEN";
    AnnouncementOperateTypeEnum["STOP_REMIND"] = "STOP_REMIND";
    AnnouncementOperateTypeEnum["CLICK_LINK"] = "CLICK_LINK";
})(AnnouncementOperateTypeEnum || (AnnouncementOperateTypeEnum = {}));
